module.exports = __webpack_public_path__ + "static/media/twitter.b7cef21b.png";